import * as React from 'react';
import * as moment from 'moment';
import { IBuyTicketsAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { removeEventFilter, upsertEventFilter } from '../../redux-state/actions/buytickets.actions';
import { IEventFilter } from '../../classes/buytickets';
import { generateEventFilter } from '../../helpers/filter-by-query';
import FilterTags from '../../views/buy-tickets-tags.view';



interface StateToProps {
    eventFilters: IEventFilter[]
}

interface DispatchToProps {
    removeFilter: (key: string, selectedValue: string, eventFilters: IEventFilter[])=> void;
}

export type FilterTagProps =  StateToProps & DispatchToProps;


export class FiltersTagContainer extends React.Component<FilterTagProps, any> {

    render() {
        return <FilterTags {...this.props}/>
    }
}

function mapStateToProps(state: IBuyTicketsAppState): StateToProps {

    return {
       eventFilters: state.calendar.eventFilter
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        removeFilter: (key: string, selectedValue: string, eventFilters: IEventFilter[]) => {
            const existingFilter = eventFilters.filter(a => a.key === key)[0];
            if (existingFilter) {
                const updated = (existingFilter.selectedValue as string).split(",").filter(a => a !== selectedValue);
                if (updated && updated.length > 0) {
                    const filter: IEventFilter = {
                        key: key,
                        selectedValue: updated.join(","),
                        filter: generateEventFilter(key, updated.join(","))
                    }
                    dispatch(upsertEventFilter(filter))
                }
                else {
                   dispatch(removeEventFilter(key))
                }
            }
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(FiltersTagContainer);